import { createSelector } from '@reduxjs/toolkit';
import { IState } from '..';
import { LoadingTypes } from './loadingTypes';

export const getIsLoading = createSelector(
  (state: IState) => state.ui.loading,
  (_: unknown, type: LoadingTypes | LoadingTypes[]) => type,
  (loading, type) => (Array.isArray(type) ? type.every(x => loading.includes(x)) : loading.includes(type))
);
